import { render } from "./QuantityTable.vue?vue&type=template&id=63470f4b"
import script from "./QuantityTable.vue?vue&type=script&lang=js"
export * from "./QuantityTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__